<template>
  <div>
    <h6 style="margin: 0px !important">{{ CEKTOPLAM }}</h6>
    <p style="color: #ea5455; margin: 0px !important">{{ PUANCEK }}</p>
  </div>
</template>
<script>
import { BBadge } from "bootstrap-vue";
export default {
  components: {
    BBadge,
  },
  data() {
    return {
      CEKTOPLAM: 0.0,
      PUANCEK: 0.0,
    };
  },
  methods: {
    gelenData() {
      this.CEKTOPLAM = this.currencyFormatter(this.params.data.CEKTOPLAM, "₺");
      this.PUANCEK = this.currencyFormatter(this.params.data.PUANCEK, " ");
    },
    currencyFormatter(currency, sign) {
      if (currency == "") {
        return 0.0;
      } else {
        var parfloat = parseFloat(currency);
        var sansDec = parfloat.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return sign + `${formatted}`;
      }
    },
  },
  created() {
    this.gelenData();
  },
};
</script>
